<script >
	
	import { link } from "svelte-routing";
	import { onMount } from 'svelte';

	let y = 0;
	let navOffset = 0;
	export let changeNavElement = false;
	export let isUserLogedIn = false;
	let scrollId = localStorage.getItem('scrollId');


	$:navOffset = window.pageYOffset;

	onMount(() => {
		var el = document.querySelector(scrollId);

		const header = document.querySelector('#header');
		

		if (!el){
			return;	
		} 
		else{
				
			header.style.top = navOffset; 
			el.scrollIntoView({
		      behavior: 'smooth'
		    });
		    localStorage.setItem('scrollId',null);
		}
	});

	function scrollIntoView({ target }) {
		const el = document.querySelector(target.getAttribute('href'));

		const header = document.querySelector('#header');
		

		if (!el){
			return;	
		} 
		else{
				
			header.style.top = navOffset; 
			el.scrollIntoView({
		      behavior: 'smooth'
		    });
		}
	}


	function changePageAndScroll({target}){

		// scrollId = target.getAttribute('name');

		// console.log('scrollId:', scrollId);		
		localStorage.setItem('scrollId',target.getAttribute('name'));

	}
	
	function handleLogOut(){
		localStorage.removeItem("user");
		localStorage.removeItem("token");
		localStorage.removeItem("company");
		localStorage.removeItem("appControlObj");
		window.location.href = '/';
	}

</script>

<svelte:window bind:scrollY={y}/>

{#if isUserLogedIn}
	<div class="topContainerLogedIn" id="header">

		
		<div class="logoContainer">

			<a href="/" use:link class="artisaneLogoLogedIn">
				ArtiSaneFood
			 </a>


			
		</div>

		<div class="menuContainer">
			<!-- <a href="#learnMoreContainer" class="menuItem"  on:click|preventDefault={scrollIntoView}>The Project</a>
			<a href="#ourProductsContainer" class="menuItem" on:click|preventDefault={scrollIntoView} >Food Products</a>
			<a href="#ourModelsContainer" class="menuItem" on:click|preventDefault={scrollIntoView} >Models</a>
			<a  class="menuItem" >Food Companies</a> -->
		</div>


		<div class="signUpBtnContainer">

			<div class="signUpBtn">
				<a  on:click={handleLogOut} class="signUpBtnTxtLogedIn">
					Log Out
				</a>	
			</div>

		</div> 
	</div>
{:else}
	{#if changeNavElement}
		<div class="topContainer" id="header">

		
			<div class="logoContainer">

				<a href="/" use:link class="artisaneLogo">
					ArtiSaneFood
				 </a>


				
			</div>

			<div class="menuContainer">
				<a href="/" name="#learnMoreContainer" class="menuItem"  on:click={changePageAndScroll}>The Project</a>
				<a href="/" name="#ourProductsContainer" class="menuItem" on:click={changePageAndScroll} >Food Products</a>
				<a href="/" name="#ourModelsContainer" class="menuItem" on:click={changePageAndScroll} >Models</a>
				<a  class="menuItem" >Food Companies</a>
			</div>


			<div class="signUpBtnContainer">

				<div class="signUpBtn">
					<a href="/signUp" use:link class="signUpBtnTxt">
						Sign Up
					</a>	
				</div>

			</div> 
		</div>
	{:else}
		<div class="topContainer" id="header">

		
			<div class="logoContainer">

				<a href="#mainContainer" use:link class="artisaneLogo" on:click|preventDefault={scrollIntoView}>
					ArtiSaneFood
				 </a>


				
			</div>

			<div class="menuContainer">
				<a href="#learnMoreContainer" class="menuItem"  on:click|preventDefault={scrollIntoView}>The Project</a>
				<a href="#ourProductsContainer" class="menuItem" on:click|preventDefault={scrollIntoView} >Food Products</a>
				<a href="#ourModelsContainer" class="menuItem" on:click|preventDefault={scrollIntoView} >Models</a>
				<a  class="menuItem" >Food Companies</a>
			</div>


			<div class="signUpBtnContainer">

				<div class="signUpBtn">
					<a href="/signUp" use:link class="signUpBtnTxt">
						Sign Up
					</a>	
				</div>

			</div> 
		</div>
	{/if}
{/if}







<style >


	


@media only screen and (min-width: 768px) {

	.topContainer{
		/*background-image: url('/img/orangeBack.png');*/
		/*background-size: cover;*/
		/*background-repeat: no-repeat;*/
		background-color: transparent;
		width: 100%;
		height:9%;
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		position: absolute;
		z-index: 99;
		opacity: 1;

	}

	.topContainerLogedIn{
		background-color:var(--brand);
		width: 100%;
		height:9%;
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		position: static;
	}

	.topContainer::before{
		content: "";
		/*background-color: white;*/
		background-image: url('/img/orangeBack.png');
		background-size: cover;
		background-repeat: no-repeat;
		position: absolute;
		top: 0px;
		right: 0px;
		bottom: 0px;
		left: 0px;
		opacity: 0.9;
	}

	.logoContainer{
		width: 20%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;

	}

	.artisaneLogo{
		width: 40%;
		height: 100%;
		color: #333333 ;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-style: normal;
		font-weight: 900;
		font-size: 2.2vw;
		margin-left: 13.2%;
		z-index: 2;
	}

	.artisaneLogo:hover{
		opacity: 1;
		color: white;
	}
	.artisaneLogo:active{
		border-color: red;
		border-style: solid;
		border-width: 0px;
		-moz-outline-style: none;
		 outline: 0;
	}
	.artisaneLogo:focus{
		border-style: solid;
		border-width: 0px;
		-moz-outline-style: none;
		 outline: 0;
	}

	.artisaneLogoLogedIn{
		width: 40%;
		height: 100%;
		/*color: var(--app-nav-web-text-color);*/
		color:  white;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-style: normal;
		font-weight: 900;
		font-size: 2.1vw;
		margin-left: 2%;
	}


	
	/*@keyframes artisaneLogo {
		0% {
			opacity: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-left: 57%;
			margin-top: 52%;
			transform: scale(0) rotate(0deg);
			

			
		}
		98%{
			display: flex;
			align-items: center;
			justify-content: center;
			margin-left: 57%;
			margin-top: 52%;
			transform: scale(7) rotate(720deg);
		}

		100% {
			
			opacity: 0;
		}
	}*/


	.menuContainer{
		width: 70%;
		height: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-evenly;		
	}

	.menuItem{
		color: black;
		font-family: "Ubuntu",Tahoma,"Helvetica Neue",Helvetica,Arial,sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 1.2vw;
		z-index: 2;
	}

	.menuItem:hover{
		color: white;
	}


	.signUpBtnContainer{
		width: 10%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-top: 0px;

	}

	.signUpBtn{
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}


	.signUpBtnTxt{
		width: 90%;
		height: 67.65%;
		background-color:transparent;
		display: flex;
		align-items: center;
		justify-content: center;	
		color: #333333 !important;
		border:  none;
		font-style: normal;
		font-weight: 700;
		font-size: 1.2vw;
		text-align: center;
		text-transform: none;
		text-decoration: underline;
		/*animation-duration: 2.2s;
	    animation-name: signUpBtnTxt-3-Slide;
	    animation-iteration-count: 1;
		animation-timing-function:cubic-bezier(0.0, 0.0, 1.0, 1.0);*/
		z-index: 2;
		cursor: pointer;

	}

	.signUpBtnTxtLogedIn{
		width: 90%;
		height: 67.65%;
		background-color:transparent;
		display: flex;
		align-items: center;
		justify-content: center;	
		color: white;
		opacity: 1;
		border:  none;
		font-style: normal;
		font-weight: 700;
		font-size: 1.2vw;
		text-align: center;
		text-transform: none;
		text-decoration: underline;
		text-decoration-color: white;
		/*animation-duration: 2.2s;
	    animation-name: signUpBtnTxt-3-Slide;
	    animation-iteration-count: 1;
		animation-timing-function:cubic-bezier(0.0, 0.0, 1.0, 1.0);*/
		z-index: 2;
		cursor: pointer;
	}

	.signUpBtnTxtLogedIn:hover{
		color: white;
		text-decoration: underline;
		text-decoration-color: white;
		background-color: var(--brand);
		/*box-shadow: 4px 0px 4px rgba(0, 0, 0, 0.2);*/
		box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
		border-radius: 3px;
	}


	.signUpBtnTxt:hover{
		color: black;
		background-color: white;
		box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
		border-radius: 3px;

	}
}

</style>